import Highcharts from "highcharts";
import {
  chartBackgroundColor,
  controlCategoryDataLabelFormatter,
} from "./globals";
import { riskColorRangeRedToGreen } from "./risk_colors";

document.addEventListener("turbo:load", () => {
  const stops: [number, string][] = [
    [0.0, riskColorRangeRedToGreen[10]],
    [0.1, riskColorRangeRedToGreen[20]],
    [0.2, riskColorRangeRedToGreen[30]],
    [0.3, riskColorRangeRedToGreen[40]],
    [0.4, riskColorRangeRedToGreen[50]],
    [0.5, riskColorRangeRedToGreen[60]],
    [0.6, riskColorRangeRedToGreen[70]],
    [0.7, riskColorRangeRedToGreen[80]],
    [0.8, riskColorRangeRedToGreen[90]],
    [0.9, riskColorRangeRedToGreen[100.01]],
  ];

  const charts: NodeListOf<HTMLElement> = document.querySelectorAll(
    "[data-chart='control_categories']",
  );

  if (charts) {
    Array.from(charts).forEach((chart) => {
      const averageScore = JSON.parse(chart.dataset.averageScore!);
      const score = JSON.parse(chart.dataset.score!);

      Highcharts.chart({
        chart: {
          renderTo: chart,
          backgroundColor: chartBackgroundColor,
          spacing: [0, 0, 0, 0],
          type: "solidgauge",
          height: 300,
        },
        title: { text: undefined },
        yAxis: {
          plotBands: [
            {
              from: averageScore == false ? 0 : averageScore,
              to: averageScore == false ? 0 : averageScore + 1,
              color: "lightgray",
              borderWidth: 0,
              borderColor: "black",
              thickness: 0,
              zIndex: 0,
            },
          ],
          lineWidth: 0,
          labels: {
            enabled: false,
          },
          minorTicks: false,
          min: 0,
          max: 100,
          tickWidth: 0,
          stops: stops,
        },
        tooltip: {
          enabled: false,
        },
        pane: {
          borderRadius: 0,
          center: ["50%", "50%"],
          startAngle: 0,
          endAngle: 360,
          size: "85%",
          background: [
            {
              backgroundColor: "#E8ECF5",
              borderWidth: 0,
              innerRadius: "90%",
              outerRadius: "100%",
              shape: "circle",
            },
          ],
        },
        plotOptions: {
          solidgauge: {
            innerRadius: "90%",
            animation: false,
          },
        },
        series: [
          {
            type: "solidgauge",
            data: [score],
            dataLabels: {
              verticalAlign: "top",
              y: -50,
              borderWidth: 0,
              formatter: function () {
                return controlCategoryDataLabelFormatter(this, averageScore);
              },
              useHTML: true,
              style: {
                fontSize: "1.5em",
                fontWeight: "normal",
                "text-anchor": "middle",
              },
            },
          },
        ],
      });
    });
  }
});
